export default __webpack_public_path__ + "static/media/S11_pe.9d7b24c1.jpg";